/** @jsx jsx */
import React from 'react';

import styled from '@emotion/styled';
import { jsx } from '@emotion/react';
import { classNames } from '../../services/classNames';

import { media } from '../../services/media';

interface InputFieldProps {
    name: string;
    inputType: string;
    placeholder: string;
    value: string;
    onChange: () => void;
    required: boolean;
    error: string;
    errorMsg: string;
    dataEvent: string;
    pattern: string;
}

export const InputField: React.FC<InputFieldProps> = ({
    name,
    inputType = 'text',
    placeholder = '',
    value = '',
    onChange,
    required = false,
    error = false,
    errorMsg = '',
    dataEvent = '',
    pattern = '',
}) => {
    return (
        <Wrapper
            className={classNames('InputField', `InputField--${inputType}`)}
            error={error}
        >
            {inputType === 'textarea' ? (
                <Textarea
                    name={name}
                    onChange={onChange}
                    value={value}
                    placeholder={placeholder}
                    {...(required && { required: true })}
                    data-event={dataEvent || 'false'}
                />
            ) : (
                <Input
                    name={name}
                    type={inputType}
                    onChange={onChange}
                    value={value}
                    placeholder={placeholder}
                    pattern={pattern || undefined}
                    {...(required && { required: true })}
                    data-event={dataEvent || 'false'}
                />
            )}
            {error && errorMsg && <ErrorMessage>{errorMsg}</ErrorMessage>}
        </Wrapper>
    );
};

const Wrapper = styled.div<{ error: string | boolean }>`
    position: relative;

    margin-bottom: 20px;

    ${media.min('lg')} {
        margin-bottom: 40px;
    }

    ${(props) =>
        props.error &&
        `
        input, texarea {
            border-color: #ec7a7a;

        }
    `}
`;

const ErrorMessage = styled.div`
    display: block;
    margin-top: 1.4vw;
    font-size: 2.9vw;
    color: #ec7a7a;
    text-align: center;
    font-weight: 600;

    ${media.min('md')} {
        font-size: 1.6vw;
    }

    ${media.min('xl')} {
        font-size: 0.8vw;
    }
`;

const Input = styled.input`
    display: block;

    width: 100%;
    padding: 13px 16px;

    font-size: 16px;

    border: 1px solid white;
    border-radius: 25px;
    outline: none;
    background-color: #fff;

    ${media.min('lg')} {
        padding: 20px 33px;

        font-size: 32px;

        border-radius: 50px;
    }
`;

const Textarea = styled.textarea`
    display: block;

    width: 100%;
    padding: 13px 16px;

    font-size: 16px;

    border: 1px solid white;
    border-radius: 25px;
    outline: none;
    background-color: #fff;

    resize: none;
    min-height: 100px;

    ${media.min('lg')} {
        padding: 20px 33px;

        font-size: 32px;

        border-radius: 50px;
        min-height: 200px;
    }
`;
